export const selectViewMemberPatches = state => state.findAndFilterData.viewMembersUpdates.data;